<div class="lob-rule">
  <p class="rule-description">
    Enable the feature for specific lines of business. The feature will be enabled for users in these business lines.
  </p>

  <div class="common-lob">
    <h4>Common Lines of Business</h4>
    <div class="lob-chip-container">
      <div
        *ngFor="let lob of commonItems"
        class="lob-chip"
        [class.selected]="isItemSelected(lob)"
        (click)="toggleItem(lob)"
      >
        {{ lob }}
      </div>
    </div>
  </div>

  <div class="lob-input-container">
    <label for="new-line-of-business">Add Line of Business:</label>
    <div class="input-group">
      <input
        id="new-line-of-business"
        type="text"
        [formControl]="newItemControl"
        (keydown.enter)="onInputKeydown($event)"
        placeholder="Enter line of business"
      />
      <button mat-flat-button color="primary" type="button" class="fx--ml-sm" (click)="addItem()">Add</button>
    </div>
    <div *ngIf="error" class="error-message">{{ error }}</div>
  </div>

  <div class="lob-container" *ngIf="items.length > 0">
    <div class="lob-header">
      <h4>Selected Lines of Business ({{ items.length }})</h4>
      <button mat-button color="primary" type="button" (click)="clearItems()">Clear All</button>
    </div>

    <ul class="lob-list">
      <li *ngFor="let lob of items; let i = index" class="lob-item">
        <span class="lob-name">{{ lob }}</span>
        <button mat-button color="primary" type="button" (click)="removeItem(i)" aria-label="Remove">×</button>
      </li>
    </ul>
  </div>

  <div class="empty-state" *ngIf="items.length === 0">
    <p>No lines of business selected. This feature will not be enabled for any business line.</p>
  </div>
</div>
